import { render, staticRenderFns } from "./AnsList.vue?vue&type=template&id=8da81406&"
import script from "./AnsList.vue?vue&type=script&lang=js&"
export * from "./AnsList.vue?vue&type=script&lang=js&"
import style0 from "./AnsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports